import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeartRateLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.80132 4.1181C7.10521 3.20641 8.39475 3.20639 8.69867 4.1181L12.25 14.7721L13.7362 10.3137C13.9233 9.75216 14.4487 9.3735 15.0406 9.3735H17.5C17.8452 9.3735 18.125 9.65333 18.125 9.9985C18.125 10.3437 17.8452 10.6235 17.5 10.6235H15.0406C14.9867 10.6235 14.939 10.6579 14.922 10.7089L13.1987 15.8788C12.8947 16.7906 11.6052 16.7905 11.3013 15.8788L7.75 5.2249L6.26387 9.68325C6.07672 10.2447 5.55128 10.6235 4.95943 10.6235H2.5C2.15483 10.6235 1.875 10.3437 1.875 9.9985C1.875 9.65333 2.15483 9.3735 2.5 9.3735H4.95943C5.01323 9.3735 5.061 9.33908 5.07802 9.288L6.80132 4.1181Z",
		fill: "currentColor"
	})
});
export default SvgHeartRateLine;
